import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../assets/css/comman/CounterSection.css'; // Assuming you have a CSS file with the provided styles
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClock, faUsers, faCubes, faGlobe } from '@fortawesome/free-solid-svg-icons'; // Choose icons that match your data
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faClock, faUsers, faCubes, faGlobe);

const CounterSection = ({ initialCounters, targetValues, intervalDuration }) => {
    const [counters, setCounters] = useState(initialCounters);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCounters((prevCounters) =>
          prevCounters.map((counter, index) => ({
            ...counter,
            count: counter.count < targetValues[index] ? counter.count + 1 : counter.count,
          }))
        );
  
        // Check if all counters have reached their target values
        const allCountersReachedTarget = counters.every(
          (counter, index) => counter.count >= targetValues[index]
        );
  
        // If all counters reached target, clear the interval
        if (allCountersReachedTarget) {
          clearInterval(interval);
        }
      }, 500);
  
      return () => clearInterval(interval); // Cleanup interval on component unmount
    }, [initialCounters, targetValues ]);
  
    return (
      <div>
        <br />
  
        <div className="row">
          {counters.map((counter, index) => (
            <div className="column flexy-box" key={index}>
              <div className="card">
              <h3>
              <FontAwesomeIcon icon={counter.icon} /> <br /> {counter.count}<span>+</span>
            </h3>
                <p>{counter.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  CounterSection.propTypes = {
    initialCounters: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
      })
    ).isRequired,
    targetValues: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    intervalDuration: PropTypes.number.isRequired,
  };
  
  export default CounterSection;